import boFormConfig from '../bo-form-config.json';
import bogFormConfig from '../bog-form-config.json';
import type { FieldDef, SectionDef, RefDataItem } from '../../shared/composables/useFormRenderer';
import { useFormRenderer } from '../../shared/composables/useFormRenderer';
// SSM4U code-type reference data
import boRaces from '../../shared/data/ssm4u/bo-races.json';
import boCategories from '../../shared/data/ssm4u/bo-categories.json';
import boIdTypeFormats from '../../shared/data/ssm4u/bo-id-type-formats.json';
import boCitizenship from '../../shared/data/ssm4u/bo-citizenship.json';
import boTypes from '../../shared/data/ssm4u/bo-types.json';
import boTypesOfBo from '../../shared/data/ssm4u/bo-types-of-bo.json';
import boCriteria from '../../shared/data/ssm4u/bo-criteria.json';

export type { FieldDef, SectionDef, RefDataItem };

// ===== Composable =====
export function useBoFormConfig() {
  const { sharedRefData } = useFormRenderer();

  const sections = boFormConfig.sections as SectionDef[];
  const conditionalRules = boFormConfig.conditionalRules as Record<string, any>;
  const validation = boFormConfig.validation as Record<string, { pattern: string; message: string }>;

  // BO-specific refData from SSM4U JSON + shared refData
  // boCategories is keyed by boType (object of arrays), not a flat array
  const boCategoriesMap = boCategories as Record<string, RefDataItem[]>;
  const idTypeFormats = boIdTypeFormats as Record<string, any>;

  // Criteria label lookup: { "A": { value, label, desc }, ... }
  const boCriteriaMap = Object.fromEntries(
    (boCriteria as { value: string; label: string; desc: string }[]).map(c => [c.value, c])
  ) as Record<string, { value: string; label: string; desc: string }>;

  const refData: Record<string, RefDataItem[]> = {
    ...sharedRefData,
    boRaces: boRaces as RefDataItem[],
    boCitizenship: boCitizenship as RefDataItem[],
    boTypes: boTypes as RefDataItem[],
    boTypesOfBo: boTypesOfBo as RefDataItem[],
  };

  return {
    boFormConfig,
    sections,
    conditionalRules,
    validation,
    refData,
    boCategoriesMap,
    idTypeFormats,
    boCriteriaMap,
  };
}

export function useBogFormConfig() {
  const { sharedRefData } = useFormRenderer();

  const sections = bogFormConfig.sections as SectionDef[];

  const refData: Record<string, RefDataItem[]> = { ...sharedRefData };

  return {
    bogFormConfig,
    sections,
    refData,
  };
}
